import React, { useState, useEffect, useCallback, useRef } from "react";
import { Container, Row, Col, Alert } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Toast from 'react-bootstrap/Toast';
import { Autocomplete } from "@mui/material";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import InputAdornment from "@mui/material/InputAdornment";
import Tab from "@mui/material/Tab";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { addNewRule, addNewBusinessRule } from "../services/rules-services";
import { getAllFacilities } from "../services/sendingFacilities-service";
import {
  fetchRuleById,
  updateRuleRecord,
  updateBusinessRuleRecord,
  fetchRuleByBusinessRuleByID,
  fetchBusinessRuleLoincsByID,
  fetchBusinessRuleSnomedsByID,
  applyLOINCtoBusinessRuleRecord,
  applySNOMEDtoBusinessRuleRecord,
} from "../services/rules-services";
import { fetchLoincDataWithCondition } from "../services/loincCodes-service";
import { fetchSnomedDataWithCondition } from "../services/snomedCodes-service";
import {
  fetchObjectData,
  fetchCodeSetTable,
} from "../services/referenceTable-service";
import { fetchErrorCodes } from "../services/error-codes-service";
import RulesScreenDecisionTable from "./RulesScreenDecisionTable";
import {
  rulesScreenLoincCodes,
  rulesScreenSnomedCodes,
} from "../util/headcells-util";
import {
  fetchConditions,
  fetchConditionById,
} from "../services/conditions-service";
import {
  ERROR_MSG,
  S3_URL,
  OPERATORS,
  PICK_OPTIONS_DROPDOWN,
  PICK_OPTIONS_STRING,
  PICK_OPTIONS_NUMERIC,
  PICK_OPTIONS_DATE,
  DATE_FORMAT_OPERATORS,
  CODE_SETS_OPERATOR,
  RE_TABLES_OPERATOR,
  PICK_OPTIONS_DROPDOWN_VALIDATION,
  PICK_OPTIONS_AGAINST_TABLES_VALIDATION,
  HL7_FIELDS_FOR_DATE_VALUES,
  HL7_FIELDS_FOR_NUMERIC_VALUES,
  HL7_FIELDS_FOR_DROPDOWN_VALUES,
  HAS_EXPIRED_INVESTIGATION_CASE_STATUS,
} from "../services/Constants";
import _ from "lodash";
import SelectAndAttachedCodes from "./SelectAndAttachedCodes";
import RulesScreenOrCondition from "./RulesScreenOrCondition";
import RulesScreenDecisionTableForSyphilis from "./RulesScreenDecisionTableForSyphilis";
import { FixedSizeList } from "react-window";
import { validateAndSanitizeUrl } from "../util/common";

const AntTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    minWidth: 0,
    [theme.breakpoints.up("sm")]: {
      minWidth: 0,
    },
    marginRight: theme.spacing(1),
    color: "#0365C0",
    fontWeight: 400,
    fontSize: "16px",
    backgroundColor: "#FFFFFF",
    fontFamily: ["Roboto"].join(","),
    "&:hover": {
      color: "#0839AD",
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "#000000",
      fontWeight: theme.typography.fontWeightBold,
    },
    "&.Mui-focusVisible": {
      backgroundColor: "#000000",
    },
  })
);

const RulesScreen = () => {
  const childRef = useRef(null);
  const [form, setForm] = useState({});
  const [validated, setValidated] = useState(false);
  const [alertMessage, setAlertMessage] = useState();
  const [inputConditions, setInputConditions] = useState([
    {
      sourceObject: "",
      sourceField: "",
      operator: "",
      valueRhs: "",
      seqNum: "1",
    },
  ]);
  const [inputActions, setInputActions] = useState([
    {
      sourceObject: "",
      sourceField: "",
      operator: "",
      valueRhs: "",
      seqNum: "1",
    },
  ]);
  const navigate = useNavigate();
  const location = useLocation();

  const landingTab = () => {
    let tab = "1";

    if (location?.state?.landingTab) {
      tab = location?.state?.landingTab;
    }
    return tab;
  };

  const [formatTab, setFormatTab] = useState(landingTab());
  const [errorCode, setErrorCode] = useState("");
  const [facilityData, setFacilityData] = useState([]);
  const [filter, setFilter] = useState({});
  const [loincData, setLoincData] = useState(null);
  const [snomedData, setSnomedData] = useState(null);
  const [loincDataCondition, setLoincDataCondition] = useState();
  const [objectsData, setObjectsData] = useState([]);
  const [codeSets, setCodeSets] = useState([]);
  const [errorCodes, setErrorCodes] = useState([]);
  const [loincRecordsPerPage, setLoincRecordsPerPage] = useState(5);
  const [snomedRecordsPerPage, setSnomedRecordsPerPage] = useState(5);
  const [loincPageNo, setLoincPageNo] = useState(0);
  const [snomedPageNo, setSnomedPageNo] = useState(0);
  const [isFetchError, setIsFetchError] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [attachedLoincCodes, setAttachedLoincCodes] = useState([]);
  const [attachedSnomedCodes, setAttachedSnomedCodes] = useState([]);
  const [selectedLoincRows, setSelectedLoincRows] = useState([]);
  const [selectedSnomedRows, setSelectedSnomedRows] = useState([]);
  const [conditions, setConditions] = useState([]);
  const [rulesList, setRulesList] = useState([]);
  const [showRemoveWarningModal, setShowRemoveWarningModal] = useState(false);
  const handleRemoveWarningModalClose = () => setShowRemoveWarningModal(false);
  const [orCondition, setOrCondition] = useState("1&&2");
  const [orNameCondition, setOrNameCondition] = useState(
    "<Test Result> And <Condition>"
  );
  const [ignoreTestResult, setIgnoreTestReslt] = useState(false);
  const [isValidCodeSetsConditions, setIsValidCodeSetsConditions] =
    useState(true);
  const [isValidReTablesConditions, setIsValidReTablesConditions] =
    useState(true);

  const handleFilterModalClose = () => setShowFilterModal(false);
  const [administrativeSexCodeSets, setAdministrativeSexCodeSets] = useState(
    []
  );
  const [raceCodeSets, setRaceCodeSets] = useState([]);
  const [testMethodCodeSets, setTestMethodCodeSets] = useState([]);
  const [testMethodCheckedValues, setTestMethodCheckedValues] = useState([]);
  const [ethnicGroupCodeSet, setEthnicGroupCodeSet] = useState([]);
  const [patientDeathIndicatorCodeSets, setPatientDeathIndicatorCodeSets] =
    useState([]);
  const [specimenSourceSite, setSpecimenSourceSite] = useState([]);
  const [specimenType, setSpecimenType] = useState([]);
  const [caseTestResult, setCaseTestResult] = useState([]);
  const [existingCaseCodeSets, setExistingCaseCodeSets] = useState([]);
  const [existingCaseNumber, setExistingCaseNumbers] = useState([]);
  const [selectedSendingFacility, setSelectedSendingFacility] = useState([]);
  const [name, setName] = useState("");
  const [syphilisTestCombinationTable, setSyphilisTestCombinationTable] =
    useState([]);  
  const [multipleTierOnePositiveTests, setMultipleTierOnePositiveTests] =
    useState([]);
  const [existingSingleSyphilisTestFlag, setExistingSingleSyphilisTestFlag] =
    useState([]);
  const [hasClosedInvestigationStatus, setHasClosedInvestigationStatus] =
    useState([]); 
     const [lockStatus, setLockStatus] =
    useState([]);

  const [caseStatus, setCaseStatus] = useState([]);
  const [caseType, setCaseType] = useState([]);
  const [
    hasExpiredInvestigationCaseStatus,
    setHasExpiredInvestigationCaseStatus,
  ] = useState([]);
  const [toastShow, setToastShow] = useState(true);


  const urlWithParams = (filter) => {
    let loincCode = filter?.searchText ? filter?.searchText : "";
    let testMethod = filter?.testMethod?.length > 0 ? filter?.testMethod : [];
    let isActive = [];

    if (filter?.active) {
      isActive.push("true");
    }
    if (filter?.inactive) {
      isActive.push("false");
    }

    let params = "";

    if (loincCode !== "") {
      params += `&loincCode=${loincCode}`;
    }
    if (testMethod.length > 0) {
      params += `&testMethod=${testMethod.toString()}`;
    }
    if (isActive.length > 0) {
      params += `&isActive=${isActive.toString()}`;
    }

    return params;
  };

  const handleTestMethodCheckboxChange = (event) => {
    let copyCheckedValues = [...testMethodCheckedValues];

    if (copyCheckedValues.includes(event.target.name)) {
      copyCheckedValues = copyCheckedValues.filter(
        (item) => item !== event.target.name
      );
    } else {
      copyCheckedValues = [...copyCheckedValues, event.target.name];
    }
    setTestMethodCheckedValues(copyCheckedValues);
    setFilterField("testMethod", copyCheckedValues);
  };

  const getLoincData = useCallback(
    async (condition, filter) => {
    //Handling comma in Condition Manually
    let updatedCondition = condition.includes(',')
      ? `${condition}&condition=AnotherCondition`
      : condition;
      
      let data = await fetchLoincDataWithCondition(
        loincPageNo,
        loincRecordsPerPage,
        updatedCondition,
        urlWithParams(filter)
      );
      if (data.genericList != null) {
        setLoincData(data);
      } else {
        setIsFetchError(true);
      }
    },
    [loincPageNo, loincRecordsPerPage]
  );

  const getSnomedData = useCallback(
    async (condition) => {
    //Handling comma in Condition Manually
    let updatedCondition = condition.includes(',')
    ? `${condition}&condition=AnotherCondition`
    : condition;

      let data = await fetchSnomedDataWithCondition(
        snomedPageNo,
        snomedRecordsPerPage,
        updatedCondition
      );
      if (data.genericList != null) {
        setSnomedData(data);
      } else {
        setIsFetchError(true);
      }
    },
    [snomedPageNo, snomedRecordsPerPage]
  );

  const getFacilities = async () => {
    let response = await getAllFacilities();
    if (response.ok) {
      let data = await response.json();
      setFacilityData(data);
    } else {
      let error = await response.json();
      setAlertMessage(error?.description);
    }
  };

  //Merge in Common later
  const getColumnsMetaData = () => {
    let result = {};
    objectsData &&
      objectsData.forEach((element) => {
        let refValues = element.refTableValues;
        refValues.forEach((item) => {
          result = Object.assign(
            { [item.reference_code]: item.reference_Code_description },
            result
          );
        });
      });
    result = Object.assign(
      result,
      { object: "Object" },
      { Result: "Test Result" },
      { condition: "Condition" }
    );

    return result;
  };

  const getColumnName = (data, seqNum) => {
    let name = data?.rules.map((item, i) => {
      for (let i = 0; i < item.ruleConditions.length; i++) {
        if (seqNum === item.ruleConditions[i].seqNum) {
          let ab = getColumnsMetaData();
          let cd = ab[item.ruleConditions[i].sourceField];
          return cd;
        }
      }
    });
    return name[0] === undefined ? "<Object>" : " <" + name[0] + "> ";
  };

  function getColumnNameCondition(data, str) {
    let inputString = str.replace(/\d+/g, (digit) => {
      const index = parseInt(digit, 10);
      return getColumnName(data, index);
    });
    inputString = inputString.replace(/&&+/g, "And");
    inputString = inputString.replace(/\|\|+/g, "Or");
    inputString = inputString.replace(/\)And/g, ") <And");
    inputString = inputString.replace(/And\(/g, "And> (");
    inputString = inputString.replace(/\)And\(/g, ") <And> (");
    return inputString;
  }

  const getBusinessRuleData = async (id) => {
    let response = await fetchRuleByBusinessRuleByID(id);

    if (response.ok) {
      let data = await response.json();
      setForm({
        ruleName: data.businessRuleName,
        status: data.isActive ? "active" : "inactive",
        description: data.businessRuleDesc,
      });
      if (data?.expression != null) {
        setOrCondition(data?.expression);
        let columnNameCondition =
          objectsData.length > 0 &&
          getColumnNameCondition(data, data?.expression);
        setOrNameCondition(columnNameCondition);
        columnNameCondition.includes("<Test Result>")
          ? setIgnoreTestReslt(false)
          : setIgnoreTestReslt(true);
      } else {
        const formattedString = Array.from(
          { length: data?.rules[0]?.ruleConditions.length },
          (_, i) => (i + 1).toString()
        ).join("&&");
        setOrCondition(formattedString);
        let columnNameCondition =
          objectsData.length > 0 &&
          getColumnNameCondition(data, formattedString);
        setOrNameCondition(columnNameCondition);
        columnNameCondition.includes("<Test Result>")
          ? setIgnoreTestReslt(false)
          : setIgnoreTestReslt(true);
      }
      let conditionResponse = await fetchConditionById(data.conditionId);
      if (conditionResponse.ok) {
        let condition = await conditionResponse.json();
        setLoincDataCondition(condition.conditionName);
      }
      setRulesList(data.rules);
    } else {
      let error = await response.json();
      setAlertMessage(error.description);
    }
  };

  const getBusinessRuleLoincs = async (id) => {
    let data = await fetchBusinessRuleLoincsByID(id);
    Array.isArray(data) && setAttachedLoincCodes(data);
  };

  const getBusinessRuleSnomeds = async (id) => {
    let data = await fetchBusinessRuleSnomedsByID(id);
    Array.isArray(data) && setAttachedSnomedCodes(data);
  };

  const compare = (a, b) => {
    if (a.seqNum < b.seqNum) return -1;
    if (a.seqNum > b.seqNum) return 1;
    return 0;
  };

  const getFacilitiesInfoById = (sendingFacilityIds) => {
    let matchingFacilities;
    if (Array.isArray(sendingFacilityIds)) {
      matchingFacilities = facilityData.filter((item) =>
        sendingFacilityIds.includes(item.sendingFacilityId)
      );
    } else {
      matchingFacilities = facilityData.filter(
        (item) => item.sendingFacilityId === sendingFacilityIds
      );
    }

    return matchingFacilities;
  };

  const getConditions = async () => {
    let response = await fetchConditions();

    if (response.ok) {
      let data = await response.json();

      if (data?.length > 0) {
        setConditions(data);
      } else {
        setIsFetchError(true);
        let error = await response.json();
        setAlertMessage(error?.description);
      }
    } else {
      let error = await response.json();
      setIsFetchError(true);
      setAlertMessage(error?.description);
    }
  };

  const getObjects = async () => {
    let data = await fetchObjectData();
    if (data !== ERROR_MSG) {
      setObjectsData(data);
    } else {
      setIsFetchError(true);
    }
  };

  const getErrorCodes = async () => {
    let response = await fetchErrorCodes();
    if (response.ok) {
      let data = await response.json();
      setErrorCodes(data);
    }
  };

  const setLoincRecordsPerPageCallback = (value) => {
    setLoincRecordsPerPage(value);
  };

  const setSnomedRecordsPerPageCallback = (value) => {
    setSnomedRecordsPerPage(value);
  };

  const setLoincPageNoCallback = (value) => {
    setLoincPageNo(value);
  };

  const setSnomedPageNoCallback = (value) => {
    setSnomedPageNo(value);
  };

  const setSelectedLoincRowCallback = (rows) => {
    setSelectedLoincRows(rows);
  };

  const setSelectedSnomedRowCallback = (rows) => {
    setSelectedSnomedRows(rows);
  };

  const getRuleById = async () => {
    let ruleId = location.state.selectedRow.ruleId;
    let response = await fetchRuleById(ruleId);
    if (response.ok) {
      let data = await response.json();
      setForm({
        ruleName: data.ruleName,
        status: data.isActive ? "active" : "inactive",
        facilities: getFacilitiesInfoById(
          data.sendingFacilityIds
            ? data.sendingFacilityIds
            : data.sendingFacilityId
        ),
        description: data.ruleDescription,
      });
      setSelectedSendingFacility(
        getFacilitiesInfoById(
          data.sendingFacilityIds
            ? data.sendingFacilityIds
            : data.sendingFacilityId
        )
      );

      let conditions = data.ruleConditions.sort(compare);
      setInputConditions(conditions);
      if (
        data.ruleActions.length === 1 &&
        data.ruleActions[0].sourceObject === ""
      ) {
        let sendToValue =
          data.ruleActions[0].valueRhs === "sendToUnknownProvider" ||
          data.ruleActions[0].valueRhs === "discardMessage"
            ? data.ruleActions[0].valueRhs
            : "sendToErrorQueue";
        if (
          data.ruleActions[0].valueRhs !== "sendToUnknownProvider" &&
          data.ruleActions[0].valueRhs !== "discardMessage"
        ) {
          setErrorCode(data.ruleActions[0].valueRhs);
        }
        setForm({
          ruleName: data.ruleName,
          status: data.isActive ? "active" : "inactive",
          facilities: getFacilitiesInfoById(
            data.sendingFacilityIds
              ? data.sendingFacilityIds
              : data.sendingFacilityId
          ),
          description: data.ruleDescription,
          sendTo: sendToValue,
        });
        setSelectedSendingFacility(
          getFacilitiesInfoById(
            data.sendingFacilityIds
              ? data.sendingFacilityIds
              : data.sendingFacilityId
          )
        );
        setInputActions([
          {
            sourceObject: "",
            sourceField: "",
            operator: "",
            valueRhs: "",
            seqNum: "1",
          },
        ]);
      } else {
        let actions = data.ruleActions.sort(compare);
        setInputActions(actions);
      }
    } else {
      setIsFetchError(true);
      let error = await response.json();
      setAlertMessage(error?.description);
    }
  };

  const setField = (field, value) => {
    if (
      field === "sendTo" &&
      (value === "sendToUnknownProvider" || value === "discardMessage")
    ) {
      setErrorCode("");
    }
    setForm({
      ...form,
      [field]: value,
    });
  };

  const setFilterField = (field, value) => {
    setFilter({
      ...filter,
      [field]: value,
    });
  };

  const handleShowFilter = () => {
    setShowFilterModal(true);
  };

  const handleFilter = (event) => {
    event.preventDefault();
    setLoincPageNo(0);
    loincPageNo === 0 && getLoincData(loincDataCondition, filter);
    handleFilterModalClose();
  };

  const handleResetFilter = () => {
    setTestMethodCheckedValues([]);
    setFilter({});
  };

  const setExpandedAccordion = () => {
    let active = [];
    if (testMethodCheckedValues.length > 0) {
      active.push("0");
    }
    if (filter?.active || filter?.inactive) {
      active.push("1");
    }
    return active;
  };

  const getFieldOptions = (condition) => {
    let fields = [];
    if (condition === "Message") {
      fields = objectsData.filter(
        (item) => item.referenceTableName === "MessageObject"
      );
    } else if (condition === "Surveillance System") {
      fields = objectsData.filter(
        (item) => item.referenceTableName === "Surveillance SystemObject"
      );
    } else if (condition === "Configurations") {
      fields = objectsData.filter(
        (item) => item.referenceTableName === "ConfigurationsObject"
      );
    }
    return fields.length > 0
      ? _.sortBy(
          fields[0].refTableValues,
          (item) => item.reference_Code_description
        )
      : [];
  };

  const getDropdownCodeSets = async (tableName) => {
    let response = await fetchCodeSetTable(tableName);
    if (response.ok) {
      let data = await response.json();
      if (tableName === "Code Set") {
        setCodeSets(data.refTableValues);
      } else if (tableName === "Administrative Sex") {
        setAdministrativeSexCodeSets(data.refTableValues);
      } else if (tableName === "Race") {
        setRaceCodeSets(data.refTableValues);
      } else if (tableName === "Ethnic Group") {
        setEthnicGroupCodeSet(data.refTableValues);
      } else if (tableName === "Patient Death Indicator") {
        setPatientDeathIndicatorCodeSets(data.refTableValues);
      } else if (tableName === "Existing Case") {
        setExistingCaseCodeSets(data.refTableValues);
      } else if (tableName === "Specimen Source") {
        setSpecimenType(data.refTableValues);
      } else if (tableName === "Case Test Result") {
        setCaseTestResult(data.refTableValues);
        // } else if (tableName === "Specimen Source Site") {
        // setSpecimenSourceSite(data.refTableValues);
      } else if (tableName === "Existing Case Number") {
        setExistingCaseNumbers(data.refTableValues);
      } else if (tableName === "Syphilis Test Combination Status") {
        setSyphilisTestCombinationTable(data.refTableValues);
      } else if (tableName === "Multiple Tier One Positive Tests") {
        setMultipleTierOnePositiveTests(data.refTableValues);
      } else if (tableName === "Existing Single Syphilis Test Flag") {
        setExistingSingleSyphilisTestFlag(data.refTableValues);
      } else if (tableName === "Has Closed Investigation Status") {
        setHasClosedInvestigationStatus(data.refTableValues);
      } else if (tableName === "Lock Status") {
        setLockStatus(data.refTableValues);
      } else if (tableName === "Case Status") {
        setCaseStatus(data.refTableValues);
      } else if (tableName === "Case Type") {
        setCaseType(data.refTableValues);
      } else if (tableName === HAS_EXPIRED_INVESTIGATION_CASE_STATUS) {
        setHasExpiredInvestigationCaseStatus(data.refTableValues);
      } else if (tableName === "Test Method") {
        setTestMethodCodeSets(data.refTableValues);
      }
    }
  };

  const getOperatorsOptions = (object, field) => {
    let fields = objectsData.filter((item) => item.description === object);
    let item = [];
    let operators = {};
    let value = "";
    if (fields.length > 0) {
      item = fields[0].refTableValues.filter(
        (item) => item.reference_code === field
      );
    }
    if (item.length > 0) {
      value = item[0].reference_Code_system;
    }
    if (value === "string") {
      operators = _.pick(OPERATORS, PICK_OPTIONS_STRING);
    } else if (value === "numeric") {
      operators = _.pick(OPERATORS, PICK_OPTIONS_NUMERIC);
    } else if (value === "date") {
      operators = _.pick(OPERATORS, PICK_OPTIONS_DATE);
    } else if (value === "dropdown") {
      operators = _.pick(OPERATORS, PICK_OPTIONS_DROPDOWN);
    }
    return Object.entries(operators);
  };

  const getValidationOperatorsOptions = (object, field) => {
    let fields = objectsData.filter((item) => item.description === object);
    let item = [];
    let operators = {};
    let value = "";
    if (fields.length > 0) {
      item = fields[0].refTableValues.filter(
        (item) => item.reference_code === field
      );
    }
    if (item.length > 0) {
      value = item[0].reference_Code_system;
    }
    if (["OBX3.1", "OBX5.1", "eICR Condition Code"].includes(field)) {
      operators = _.pick(OPERATORS, PICK_OPTIONS_AGAINST_TABLES_VALIDATION);
    } else if (value === "string") {
      operators = _.pick(OPERATORS, PICK_OPTIONS_STRING);
    } else if (value === "numeric") {
      operators = _.pick(OPERATORS, PICK_OPTIONS_NUMERIC);
    } else if (value === "date") {
      operators = _.pick(OPERATORS, PICK_OPTIONS_DATE);
    } else if (value === "dropdown") {
      operators = _.pick(OPERATORS, PICK_OPTIONS_DROPDOWN_VALIDATION);
    }
    return Object.entries(operators);
  };

  const handleFormatTabChange = (event, newValue) => {
    setSelectedLoincRows([]);
    setSelectedSnomedRows([]);
    setAttachedLoincCodes([]);
    setAttachedSnomedCodes([]);
    setFormatTab(newValue);
    setForm({});
    setInputConditions([
      {
        sourceObject: "",
        sourceField: "",
        operator: "",
        valueRhs: "",
        seqNum: "1",
        logicalOperator: "",
      },
    ]);
    setInputActions([
      {
        sourceObject: "",
        sourceField: "",
        operator: "",
        valueRhs: "",
        seqNum: "1",
      },
    ]);
    setErrorCode("");
  };

  const addConditionsFields = () => {
    let lastElement = inputConditions.slice(-1);
    let newfield = {
      sourceObject: inputConditions[0].sourceObject,
      sourceField: "",
      operator: "",
      valueRhs: "",
      seqNum: (parseInt(lastElement[0].seqNum) + 1).toString(),
      logicalOperator:
        inputConditions.length === 1 ? "&&" : lastElement[0].logicalOperator,
    };
    setInputConditions([...inputConditions, newfield]);
  };

  const addActionsFields = () => {
    let lastElement = inputActions.slice(-1);
    let newfield = {
      sourceObject: inputActions[0].sourceObject,
      sourceField: "",
      operator: "",
      valueRhs: "",
      seqNum: (parseInt(lastElement[0].seqNum) + 1).toString(),
    };
    setInputActions([...inputActions, newfield]);
  };

  const handleFormConditionsChange = (index, event) => {
    let data = [...inputConditions];
    data[index][event.target.name] = event.target.value;
    setInputConditions(data);

    if (event.target.name === "sourceObject") {
      setForm({
        ...form,
        sendTo: null,
      });
      setInputConditions(
        inputConditions.map((item) => {
          return {
            ...item,
            sourceObject: inputConditions.at(0).sourceObject,
            sourceField: "",
            operator: "",
          };
        })
      );
      setInputActions(
        inputActions.map((item) => {
          return {
            ...item,
            sourceObject: inputConditions.at(0).sourceObject,
            sourceField: "",
            operator: "",
          };
        })
      );
    }
    if (event.target.name === "logicalOperator") {
      setInputConditions(
        inputConditions.map((item) => {
          return {
            ...item,
            logicalOperator: inputConditions.at(1).logicalOperator,
          };
        })
      );
    }
  };

  const handleFormActionsChange = (index, event) => {
    let data = [...inputActions];
    data[index][event.target.name] = event.target.value;
    setInputActions(data);
  };

  const removeConditionsFields = (index) => {
    let data = [...inputConditions];
    data.splice(index, 1);
    let startingSeq = 0;
    setInputConditions(
      data.map((item) => {
        startingSeq++;
        return { ...item, seqNum: startingSeq.toString() };
      })
    );
  };

  const removeActionsFields = (index) => {
    let data = [...inputActions];
    data.splice(index, 1);
    let startingSeq = 0;
    setInputActions(
      data.map((item) => {
        startingSeq++;
        return { ...item, seqNum: startingSeq.toString() };
      })
    );
  };

  const addRule = async (payload) => {
    let data = await addNewRule(payload);
    if (data.ruleId != null) {
      return true;
    } else {
      return false;
    }
  };

  const addBusinessRule = async (payload) => {
    let response = await addNewBusinessRule(payload);

    if (response.ok) {
      let data = await response.json();
      if (data.businessRuleId != null) {
        return data;
      } else {
        return false;
      }
    } else {
      let error = await response.json();
      setAlertMessage(error.description);
    }
  };

  const updateRule = async (payload) => {
    let data = await updateRuleRecord(payload);
    if (data.ruleId != null) {
      return true;
    } else {
      return false;
    }
  };

  const updateBusinessRule = async (payload) => {
    let response = await updateBusinessRuleRecord(payload);

    if (response.ok) {
      let data = await response.json();
      if (data.businessRuleId != null) {
        return data;
      } else {
        return false;
      }
    } else {
      let error = await response.json();
      setAlertMessage(error.description);
    }
  };

  const applyLOINCtoBusinessRule = async (businessRuleId, payload) => {
    let data = await applyLOINCtoBusinessRuleRecord(businessRuleId, payload);
    return data.length >= 0 ? true : false;
  };

  const applySNOMEDtoBusinessRule = async (businessRuleId, payload) => {
    let data = await applySNOMEDtoBusinessRuleRecord(businessRuleId, payload);
    return data?.businessRuleId != null ? true : false;
  };

  const updatedConditions = (ruleConditions) => {
    let copyRuleConditions = [...ruleConditions];
    const updatedRuleConditions = copyRuleConditions.map(
      (ruleCondition, index) => {
        if (ignoreTestResult && index === 0)
          return { ...ruleCondition, valueRhs: loincDataCondition };
        if (!ignoreTestResult && index === 1)
          return { ...ruleCondition, valueRhs: loincDataCondition };
        else return ruleCondition;
      }
    );
    return updatedRuleConditions;
  };

  function removeColumnsifInGrouping(copyOrConditions) {
    const regex = /\d+/g;
    const numbers = copyOrConditions.match(regex);
    const uniqueNumbers = new Set();
    if (numbers) {
      numbers.forEach((numStr) => {
        const num = parseInt(numStr, 10);
        uniqueNumbers.add(num);
      });
    }
    let columnsSeqNum = Array.from(uniqueNumbers);

    let newString = "";
    const matches = copyOrConditions.match(/\((.*?)\)/g);

    const outputArray = [];
    if (matches === null) return copyOrConditions;
    if (matches !== null && matches?.length > 0) {
      for (const match of matches) {
        newString = newString + match;
        if (match !== matches[matches.length - 1]) newString = newString + "&&";
        const numbers = match
          .replace(/[()]/g, "") // Remove parentheses
          .split("||") // Split by 'or'
          .map(Number); // Convert strings to numbers
        outputArray.push(...numbers); // Add numbers to the output array
      }
    }
    const subtractedArray = columnsSeqNum.filter(
      (item) => !outputArray.includes(item)
    );
    for (let i = subtractedArray.length - 1; i >= 0; i--) {
      let andOperator = "&&";
      newString = subtractedArray[i] + andOperator + newString;
    }
    return newString;
  }

  function removeDuplicates(inputString) {
    const parts = inputString.split("&&");
    const uniqueElements = {};
    const uniqueParts = [];
    for (const part of parts) {
      if (!uniqueElements[part]) {
        uniqueElements[part] = true;
        uniqueParts.push(part);
      }
    }
    const result = uniqueParts.join("&&");
    return result;
  }

  const constructIndividualRulePerRow = (orCondition, rule) => {
    let individualRulePerRow = "";
    individualRulePerRow =
      individualRulePerRow +
      orCondition.replace(/\d+/g, (digit) => {
        const index = parseInt(digit, 10);
        return rule.ruleConditions[index - 1]?.valueRhs === null ? "" : index;
      });

    individualRulePerRow = individualRulePerRow.replace(/(&&)+/g, "&&");
    individualRulePerRow = individualRulePerRow.replace(/(\|\|)+/g, "||");
    individualRulePerRow = individualRulePerRow.replace(/\(\|\|/g, "(");
    individualRulePerRow = individualRulePerRow.replace(/\|\|\)/g, ")");
    individualRulePerRow = individualRulePerRow.replace(/&&\(\)/g, "");
    individualRulePerRow = individualRulePerRow.replace(/&&$/g, "");
    individualRulePerRow = individualRulePerRow.replace(/\((\d+)\)/g, "$1");
    individualRulePerRow = removeDuplicates(individualRulePerRow);
    individualRulePerRow = removeColumnsifInGrouping(individualRulePerRow);
    return individualRulePerRow;
  };

  const handleSubmmitBusinessRule = async (event) => {
    event.preventDefault();
    setValidated(true);

    if (event.currentTarget.checkValidity() === true) {
      let rules = childRef.current.getRules();

      let loincList = attachedLoincCodes.map((item) => item.loincId);
      let snomedList = attachedSnomedCodes.map((item) => item.snomedId);

      let updatedRules = rules.map((item) => {
        return {
          ...item,
          rulesConditionsGroupingOrder: form.rulesConditionsGroupingOrder,
          ruleName: form.ruleName,
          ruleDescription: form.description,
          isActive: form.status === "active" ? true : false,
          ruleConditions: updatedConditions(item.ruleConditions),
          ruleExpression: constructIndividualRulePerRow(orCondition, item),
        };
      });
      let payload = {
        rulesConditionsGroupingOrder: form.rulesConditionsGroupingOrder,
        businessRuleDesc: form.description,
        businessRuleName: form.ruleName,
        expression: orCondition,
        isActive: form.status === "active" ? true : false,
        conditionId: conditions.filter(
          (item) => item.conditionName === loincDataCondition
        )[0].conditionId,
        rules: updatedRules,
      };

      let route = "";
      let responseBody = true;
      if (location?.state?.from === "errorQueue") {
        route = "/errorMessageQueue";
      }
      if (location?.state?.from === "rulesTable") {
        route = "/rules";
      }
      if (location?.state?.from === "errorMessage") {
        route = "/error";
      }
      let applyLoincsResponse = true;
      let applySnomedResponse = true;
      if (location?.state?.selectedRow?.ruleId != null) {
        let updatedPayload = {
          ...payload,
          ruleId: location?.state?.selectedRow?.ruleId,
        };
        responseBody = await updateBusinessRule(updatedPayload);
        applyLoincsResponse = await applyLOINCtoBusinessRule(
          responseBody?.businessRuleId,
          loincList
        );
        applySnomedResponse = await applySNOMEDtoBusinessRule(
          responseBody?.businessRuleId,
          snomedList
        );

        navigate(route, {
          state: {
            isUpdated: applyLoincsResponse && applySnomedResponse,
            success: applyLoincsResponse && applySnomedResponse,
            filter: location?.state?.filter,
            pageNo: location?.state?.pageNo,  
          },
        });
      } else {
        responseBody = await addBusinessRule(payload);
        if (loincList.length > 0) {
          applyLoincsResponse = await applyLOINCtoBusinessRule(
            responseBody?.businessRuleId,
            loincList
          );
        }
        if (snomedList.length > 0) {
          applySnomedResponse = await applySNOMEDtoBusinessRule(
            responseBody?.businessRuleId,
            snomedList
          );
        }
        navigate(route, {
          state: {
            isAdded: applyLoincsResponse && applySnomedResponse,
            success: applyLoincsResponse && applySnomedResponse,
            transactionId: location?.state?.transactionId
              ? location?.state?.transactionId
              : null,
              filter: location?.state?.filter,
              pageNo: location?.state?.pageNo,  
          },
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
  };

  const handleSubmmitTranslationRule = async (event) => {
    event.preventDefault();
    setValidated(true);
    if (event.currentTarget.checkValidity() === true) {
      let payload = {
        ruleName: form.ruleName,
        isActive: form.status === "active" ? true : false,
        ruleCategory: "Translation",
        ruleDescription: form.description,
        ruleConditions: inputConditions,
        ruleActions: inputActions,
        sendingFacilityIds: selectedSendingFacility.map(
          ({ sendingFacilityId }) => sendingFacilityId
        ),
      };
      let response = false;
      let route = "";
      if (location?.state?.from === "errorQueue") {
        route = "/errorMessageQueue";
      }
      if (location?.state?.from === "rulesTable") {
        route = "/rules";
      }
      if (location?.state?.from === "errorMessage") {
        route = "/error";
      }
      if (location?.state?.selectedRow?.ruleId != null) {
        let updatedPayload = {
          ...payload,
          ruleId: location.state.selectedRow.ruleId,
        };
        response = await updateRule(updatedPayload);
        navigate(route, {
          state: { isUpdated: response,  filter: location?.state?.filter,
            pageNo: location?.state?.pageNo,   },
        });
      } else {
        response = await addRule(payload);
        navigate(route, {
          state: {
            isAdded: response,
            transactionId: location?.state?.transactionId
              ? location?.state?.transactionId
              : null,
              filter: location?.state?.filter,
              pageNo: location?.state?.pageNo,  
          },
        });
      }
    }
  };

  const cancelForm = () => {
    let route = "";
    if (location?.state?.from === "errorQueue") {
      route = "/errorMessageQueue";
    }
    if (location?.state?.from === "rulesTable") {
      route = "/rules";
    }
    if (
      location?.state?.from === "errorMessage" &&
      location?.state?.transactionId
    ) {
      route = "/error";
      navigate(route, {
        state: { transactionId: location?.state?.transactionId, filter: location?.state?.filter,
          pageNo: location?.state?.pageNo,   },
      });
    } else {
      navigate(route, {
        state: { filter: location?.state?.filter,
          pageNo: location?.state?.pageNo,   },
      });
    }
  };

  const isValidCodeSetsConditionSequence = () => {
    if (
      inputConditions.some((item) => item.operator === "Code Set Value Not in")
    ) {
      return inputConditions.every(
        (item) => item.operator === "Code Set Value Not in"
      );
    }
    return true;
  };

  const isValidReTablesConditionSequence = () => {
    if (
      inputConditions.some((item) => item.operator === "RE Table Value Not in")
    ) {
      return inputConditions.every(
        (item) => item.operator === "RE Table Value Not in"
      );
    }
    return true;
  };

  const handleSubmmitValidRule = async (event) => {
    event.preventDefault();
    setValidated(true);
    if (!isValidCodeSetsConditionSequence()) {
      setIsValidCodeSetsConditions(false);
    } else if (!isValidReTablesConditionSequence()) {
      setIsValidReTablesConditions(false);
    } else if (event.currentTarget.checkValidity() === true) {
      let newValue = [
        {
          sourceObject: "",
          sourceField: "",
          operator: "",
          valueRhs:
            form.sendTo === "sendToErrorQueue" ? errorCode : form.sendTo,
          seqNum: "1",
          logicalOperator: "",
        },
      ];
      let payload = {
        ruleName: form.ruleName,
        isActive: form.status === "active" ? true : false,
        ruleCategory: "Validation",
        ruleDescription: form.description,
        ruleConditions: inputConditions,
        ruleActions: form.sendTo == null ? inputActions : newValue,
        sendingFacilityIds: selectedSendingFacility.map(
          ({ sendingFacilityId }) => sendingFacilityId
        ),
      };
      let response = false;
      let route = "";

      if (location?.state?.from === "errorQueue") {
        route = "/errorMessageQueue";
      }
      if (location?.state?.from === "rulesTable") {
        route = "/rules";
      }
      if (location?.state?.from === "errorMessage") {
        route = "/error";
      }
      if (location?.state?.selectedRow?.ruleId != null) {
        let updatedPayload = {
          ...payload,
          ruleId: location.state.selectedRow.ruleId,
        };
        response = await updateRule(updatedPayload);
        navigate(route, {
          state: { isUpdated: response, filter: location?.state?.filter,
            pageNo: location?.state?.pageNo, },
        });
      } else {
        response = await addRule(payload);
        navigate(route, {
          state: {
            isAdded: response,
            transactionId: location?.state?.transactionId
              ? location?.state?.transactionId
              : null,
              filter: location?.state?.filter,
          pageNo: location?.state?.pageNo,
          },
        });
      }
    }
  };

  const handleBackRouteMessage = () => {
    let message = "";
    let backTo = "";
    if (location?.state?.from === "errorQueue") {
      message = "Back to Error Message Queue";
      backTo = "/errorMessageQueue";
    }
    if (location?.state?.from === "rulesTable") {
      message = "Back to Rules Management";
      backTo = "/rules";
    }
    if (
      location?.state?.from === "errorMessage" &&
      location?.state?.transactionId
    ) {
      message = "Back to Message Errors";
      backTo = "/error";
      return (
        <Link
          to={backTo}
          state={{ transactionId: location?.state?.transactionId,  filter: location?.state?.filter,
            pageNo: location?.state?.pageNo, }}
          className="linkStyle"
        >
          {message}
        </Link>
      );
    }
    return (
      <Link to={backTo} className="linkStyle" state={{
        filter: location?.state?.filter,
        pageNo: location?.state?.pageNo,
      }}>
        {message}
      </Link>
    );
  };

  const showTitle = () => {
    let message = "Create New Rule";
    if (location?.state?.action === "update") {
      message = "Update Rule";
    }
    return message;
  };

  const applyLoincCodes = () => {
    setAttachedLoincCodes(selectedLoincRows);
  };

  const applySnomedCodes = () => {
    setAttachedSnomedCodes(selectedSnomedRows);
  };

  const getDropdownCodeSetsValues = (sourceField) => {
    let dropdownValues = [];
    if (sourceField === "PID8") {
      dropdownValues = administrativeSexCodeSets;
    } else if (sourceField === "PID10.1") {
      dropdownValues = raceCodeSets;
    } else if (sourceField === "PID22.1") {
      dropdownValues = ethnicGroupCodeSet;
    } else if (sourceField === "PID30") {
      let newObject = patientDeathIndicatorCodeSets.map((item) => {
        return {
          referenceTableValueId: item.referenceTableValueId,
          reference_code: item.reference_code,
          reference_Code_description: `${item.reference_Code_description} - ${item.reference_code} - ${item.reference_Code_system}`,
        };
      });
      dropdownValues = newObject;
    } else if (sourceField === "existingCase") {
      dropdownValues = existingCaseCodeSets;
    } else if (sourceField === "SPM8.1") {
      dropdownValues = specimenSourceSite;
    } else if (sourceField === "SPM4") {
      dropdownValues = specimenType;
    } else if (sourceField === "caseTestResult") {
      dropdownValues = caseTestResult;
    } else if (sourceField === "existingCaseNumber") {
      dropdownValues = existingCaseNumber;
    } else if (sourceField === "testCombinationResult") {
      dropdownValues = syphilisTestCombinationTable;
    } else if (sourceField === "multipleTierOnePositiveTests") {
      dropdownValues = multipleTierOnePositiveTests;
    } else if (sourceField === "existingSingleSyphilisTestFlag") {
      dropdownValues = existingSingleSyphilisTestFlag;
    } else if (sourceField === "lockStatus") {
      dropdownValues = lockStatus;
    } else if (sourceField === "hasClosedInvestigationStatus") {
      dropdownValues = hasClosedInvestigationStatus;
    } else if (sourceField === "caseStatus") {
      dropdownValues = caseStatus;
    } else if (sourceField === "caseType") {
      dropdownValues = caseType;
    } else if (sourceField === "hasExpiredInvestigationCaseStatus") {
      dropdownValues = hasExpiredInvestigationCaseStatus;
    }
    return dropdownValues.length > 0
      ? _.sortBy(dropdownValues, (item) => item.reference_Code_description)
      : [];
  };

  const changeConditionInputType = (input, index) => {
    if (DATE_FORMAT_OPERATORS.includes(input.operator)) {
      return (
        <Form.Select
          key={index + "Value"}
          required
          name="valueRhs"
          className="modalInput generalFont"
          type="text"
          disabled={index === 0 && inputConditions.at(0).sourceObject === ""}
          value={input.valueRhs}
          onChange={(event) => handleFormConditionsChange(index, event)}
        >
          <option hidden value="">
            Choose Item
          </option>
          <option key="MM/dd/yyyy" value="MM/dd/yyyy">
            MM/dd/yyyy
          </option>
          <option key="yyyy-MM-dd" value="yyyy-MM-dd">
            yyyy-MM-dd
          </option>
        </Form.Select>
      );
    } else if (CODE_SETS_OPERATOR.includes(input.operator)) {
      return (
        <Form.Select
          key={index + "Value"}
          required
          name="valueRhs"
          className="modalInput generalFont"
          type="text"
          disabled={index === 0 && inputConditions.at(0).sourceObject === ""}
          value={input.valueRhs}
          onChange={(event) => handleFormConditionsChange(index, event)}
        >
          <option value="">Code Sets</option>
          {_.sortBy(codeSets, ["reference_Code_description"]).map((entry) => {
            return (
              <option
                key={entry.reference_Code_description}
                value={entry.reference_Code_description}
              >
                {entry.reference_Code_description}
              </option>
            );
          })}
        </Form.Select>
      );
    } else if (RE_TABLES_OPERATOR.includes(input.operator)) {
      return (
        <Form.Select
          key={index + "Value"}
          required
          name="valueRhs"
          className="modalInput generalFont"
          type="text"
          disabled={index === 0 && inputConditions.at(0).sourceObject === ""}
          value={input.valueRhs}
          onChange={(event) => handleFormConditionsChange(index, event)}
        >
          <option value="">RE Tables</option>
          <option value="LOINC Tables">LOINC Tables</option>
          <option value="SNOMED Table">SNOMED Table</option>
        </Form.Select>
      );
    } else if (HL7_FIELDS_FOR_DATE_VALUES.includes(input.sourceField)) {
      return (
        <Form.Control
          key={index + "Value"}
          className="modalInput generalFont"
          required
          type="date"
          placeholder="Enter Date"
          name="valueRhs"
          value={input.valueRhs}
          onChange={(event) => handleFormConditionsChange(index, event)}
        />
      );
    } else if (HL7_FIELDS_FOR_NUMERIC_VALUES.includes(input.sourceField)) {
      return (
        <Form.Control
          key={index + "Value"}
          className="modalInput generalFont"
          required
          type="number"
          placeholder="Enter Value"
          name="valueRhs"
          value={input.valueRhs}
          onChange={(event) => handleFormConditionsChange(index, event)}
        />
      );
    } else if (HL7_FIELDS_FOR_DROPDOWN_VALUES.includes(input.sourceField)) {
      return (
        <Form.Select
          key={index + "Value"}
          aria-label="Choose Item"
          name="valueRhs"
          value={input.valueRhs}
          className="modalInput generalFont"
          required
          onChange={(event) => handleFormConditionsChange(index, event)}
        >
          <option hidden value="">
            Choose Item
          </option>
          {getDropdownCodeSetsValues(input.sourceField).map((val) => {
            return (
              <option key={val.reference_code} value={val.reference_code}>
                {val.reference_Code_description}
              </option>
            );
          })}
        </Form.Select>
      );
    } else {
      return (
        <Form.Control
          key={index + "Value"}
          name="valueRhs"
          className="modalInput generalFont"
          type="text"
          placeholder="Value"
          disabled={
            (index === 0 && inputConditions.at(0).sourceObject === "") ||
            (input.valueRhsDropdown != null && input.valueRhsDropdown !== "")
          }
          value={input.valueRhs}
          onChange={(event) => handleFormConditionsChange(index, event)}
        />
      );
    }
  };

  const changeActionInputType = (input, index) => {
    if (DATE_FORMAT_OPERATORS.includes(input.operator)) {
      return (
        <Form.Select
          key={index + "Value2"}
          required
          name="valueRhs"
          className="modalInput generalFont"
          type="text"
          disabled={inputActions.at(index).sourceObject === ""}
          value={input.valueRhs}
          onChange={(event) => handleFormActionsChange(index, event)}
        >
          <option hidden value="">
            Choose Item
          </option>
          <option value="MM/dd/yyyy">MM/dd/yyyy</option>
          <option value="yyyy-MM-dd">yyyy-MM-dd</option>
        </Form.Select>
      );
    } else {
      return (
        <Form.Control
          key={index + "Value2"}
          name="valueRhs"
          className="modalInput generalFont"
          type="text"
          placeholder="Value"
          disabled={inputActions.at(index).sourceObject === ""}
          value={input.valueRhs}
          onChange={(event) => handleFormActionsChange(index, event)}
        />
      );
    }
  };

  const showConditionsInvalidMessage = () => {
    if (!isValidCodeSetsConditions) {
      return (
        <Row style={{ padding: "40px 40px 0 40px" }}>
          <Alert
            key={"danger"}
            variant={"danger"}
            onClose={() => {
              setIsValidCodeSetsConditions(true);
            }}
            dismissible
          >
            Error: If “Code Set Value Not in” operator is selected in one of the
            conditions, then all conditions must have “Code Set Value Not in”
            operator selected.
          </Alert>
        </Row>
      );
    } else if (!isValidReTablesConditions) {
      return (
        <Row style={{ padding: "40px 40px 0 40px" }}>
          <Alert
            key={"danger"}
            variant={"danger"}
            onClose={() => {
              setIsValidReTablesConditions(true);
            }}
            dismissible
          >
            Error: If “RE Table Value Not in” operator is selected in one of the
            conditions, then all conditions must have “RE Table Value Not in”
            operator selected.
          </Alert>
        </Row>
      );
    }
  };

  useEffect(() => {
    setName(selectedSendingFacility);
  }, [selectedSendingFacility]);

  useEffect(() => {
    getConditions();
    if (location?.state?.selectedRow?.ruleCategory !== "Business") {
      getFacilities();
      getErrorCodes();
    }
    getObjects();
    getDropdownCodeSets("Code Set");
    getDropdownCodeSets("Administrative Sex");
    getDropdownCodeSets("Race");
    getDropdownCodeSets("Ethnic Group");
    getDropdownCodeSets("Patient Death Indicator");
    getDropdownCodeSets("Existing Case");
    // getDropdownCodeSets("Specimen Source Site");
    getDropdownCodeSets("Specimen Source");
    getDropdownCodeSets("Existing Single Syphilis Test Flag");
    getDropdownCodeSets("Test Method");
    getDropdownCodeSets("Case Status");
    getDropdownCodeSets("Case Type");
    getDropdownCodeSets("Lock Status");
    // getDropdownCodeSets(HAS_EXPIRED_INVESTIGATION_CASE_STATUS);
  }, []);

  useEffect(() => {
    loincDataCondition != null && getLoincData(loincDataCondition, filter);
  }, [loincDataCondition, loincPageNo, loincRecordsPerPage, getLoincData]);

  useEffect(() => {
    loincDataCondition != null && getSnomedData(loincDataCondition);
  }, [loincDataCondition, snomedPageNo, snomedRecordsPerPage, getSnomedData]);

  useEffect(() => {
    if (
      location?.state?.selectedRow?.ruleId != null &&
      location?.state?.selectedRow?.ruleCategory === "Business" &&
      location?.state?.action === "update" &&
      objectsData.length > 0
    ) {
      getBusinessRuleData(location?.state?.selectedRow?.ruleId);
      getBusinessRuleLoincs(location?.state?.selectedRow?.ruleId);
      getBusinessRuleSnomeds(location?.state?.selectedRow?.ruleId);
    }
  }, [objectsData]);

  useEffect(() => {
    facilityData.length !== 0 &&
      location?.state?.selectedRow?.ruleId != null &&
      location?.state?.selectedRow?.ruleCategory !== "Business" &&
      getRuleById();
  }, [facilityData]);
  return (
    <>
      <Container fluid className="errorMessageContainer">
        <Row className="tableTitle generalFont">{showTitle()}</Row>
        <Row
          className="tableSubtitle generalFont"
          style={{ width: "95%", paddingRight: "30px" }}
        >
          <Col style={{ paddingLeft: "0px" }}>
            Create new rule to be applied to incoming messages
          </Col>
          <Col style={{ display: "flex", justifyContent: "end" }}>
            {handleBackRouteMessage()}
          </Col>
        </Row>
        {alertMessage && (
          <Alert
            style={{ marginRight: "175px" }}
            variant={"danger"}
            show={alertMessage !== null && alertMessage !== "undefined"}
            onClose={() => {
              setAlertMessage();
            }}
            dismissible
          >
            {alertMessage}
          </Alert>
        )}
        <Row style={{ marginRight: "54px", marginTop: "10px" }}>
          <Box
            sx={{
              width: "100%",
              typography: "body1",
              paddingLeft: "0px",
              paddingRight: "0px",
            }}
          >
            <TabContext sx={{ height: "38px" }} value={formatTab}>
              <div
                className="generalFont"
                style={{
                  lineHeight: "22px",
                  fontSize: "16px",
                  fontWeight: "500",
                  marginBottom: "10px",
                }}
              >
                Rule Type
              </div>
              <TabList
                onChange={handleFormatTabChange}
                aria-label="Format Tabs"
              >
                <AntTab
                  label="Business Rule"
                  value="1"
                  disabled={
                    location?.state?.action === "update" &&
                    location?.state?.landingTab !== 1
                  }
                />
                <AntTab
                  label="Translation Rule"
                  value="2"
                  disabled={
                    location?.state?.action === "update" &&
                    location?.state?.landingTab !== 2
                  }
                />
                <AntTab
                  label="Validation Rule"
                  value="3"
                  disabled={
                    location?.state?.action === "update" &&
                    location?.state?.landingTab !== 3
                  }
                />
              </TabList>
              <TabPanel className="noPaddMarginTop40" value="1">
                <Form
                  onSubmit={handleSubmmitBusinessRule}
                  noValidate
                  validated={validated}
                >
                  <Col sm={2}>
                    <Form.Group className="mb-3" controlId="form.condition">
                      <Form.Label className="modalLabel generalFont">
                        Condition
                      </Form.Label>
                      <Form.Select
                        className="modalInput generalFont"
                        aria-label="Choose Item"
                        required
                        value={loincDataCondition}
                        onChange={(e) => {
                          setSelectedLoincRows([]);
                          setSelectedSnomedRows([]);
                          setLoincDataCondition(e.target.value);
                          setFilter({});
                          setLoincPageNo(0);
                          setSnomedPageNo(0);
                          setAttachedLoincCodes([]);
                          setAttachedSnomedCodes([]);
                          getLoincData(e.target.value, {});
                          getSnomedData(e.target.value, {});
                          setRulesList([]);
                          if (childRef.current) childRef.current.setNewRules();
                          ignoreTestResult
                            ? setOrCondition("1")
                            : setOrCondition("1&&2");
                          ignoreTestResult
                            ? setOrNameCondition("<Condition>")
                            : setOrNameCondition(
                                "<Test Result> And <Condition>"
                              );
                        }}
                        feedback="You must agree before submitting."
                      >
                        <option hidden value="">
                          Choose Item
                        </option>
                        {conditions
                          .filter((item) => item.isActive === "true")
                          .sort((a, b) =>
                            a.conditionName > b.conditionName ? 1 : -1
                          )
                          .map((entry) => {
                            return (
                              <option
                                key={entry.conditionId}
                                value={entry.conditionName}
                              >
                                {entry.conditionName}
                              </option>
                            );
                          })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Card className="card" style={{ marginTop: "40px" }}>
                    <Row style={{ padding: "40px 40px 0 40px" }}>
                      <div
                        className="cardBody"
                        style={{ marginBottom: "40px" }}
                      >
                        <img
                          src={`${validateAndSanitizeUrl(
                            S3_URL
                          )}rules-details-icon.png`}
                          style={{
                            width: "20px",
                            height: "18px",
                            marginRight: "15px",
                          }}
                          alt=""
                        ></img>
                        <div className="condModalHeader generalFont">
                          Rule Details
                        </div>
                      </div>
                      <Col>
                        <Form.Group className="mb-3" controlId="ruleName">
                          <Form.Label className="modalLabel generalFont">
                            Rule Name <i className="text-danger">(required)</i>
                          </Form.Label>
                          <Form.Control
                            className="modalInput generalFont"
                            type="text"
                            placeholder="Hint Text"
                            required
                            value={form.ruleName}
                            onChange={(e) =>
                              setField("ruleName", e.target.value)
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="status">
                          <Form.Label
                            className="modalLabel generalFont"
                            style={{ marginLeft: "80px" }}
                          >
                            Status <i className="text-danger">(required)</i>
                          </Form.Label>
                          <br />
                          <Form.Check
                            style={{ marginLeft: "80px", marginTop: "15px" }}
                            name="status"
                            required
                            value="active"
                            type="radio"
                            label="Active"
                            inline
                            onChange={(e) => setField("status", e.target.value)}
                            checked={form.status === "active"}
                          />
                          <Form.Check
                            name="status"
                            required
                            value="inactive"
                            type="radio"
                            label="Inactive"
                            inline
                            onChange={(e) => setField("status", e.target.value)}
                            checked={form.status === "inactive"}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row style={{ padding: "40px" }}>
                      <Col>
                        <Form.Group className="mb-3" controlId="description">
                          <Form.Label className="modalLabel generalFont">
                            Description
                          </Form.Label>
                          <Form.Control
                            className="modalInput generalFont"
                            type="text"
                            placeholder="Hint Text"
                            value={form.description}
                            onChange={(e) =>
                              setField("description", e.target.value)
                            }
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card>
                  <Card className="card" style={{ marginTop: "40px" }}>
                    <Row style={{ padding: "40px 40px 0 40px" }}>
                      <div
                        className="cardBody"
                        style={{ marginBottom: "40px" }}
                      >
                        <img
                          src={`${validateAndSanitizeUrl(
                            S3_URL
                          )}rules-details-icon.png`}
                          style={{
                            width: "20px",
                            height: "18px",
                            marginRight: "15px",
                          }}
                          alt=""
                        ></img>
                        <div className="condModalHeader generalFont">
                          Business Rules Decision Table
                        </div>
                      </div>
                      <Form.Group className="mb-3" controlId="ruleName">
                          <Row>
                            <Col>
                              <Form.Check
                                name="lookUp"
                                value={ignoreTestResult}
                                type="checkbox"
                                label="Ignore Test Result"
                                onChange={(e) => {
                                  setRulesList([]);
                                  childRef.current.setNewRules();
                                  setIgnoreTestReslt(!ignoreTestResult);
                                  if (e.target.value === "false") {
                                    setOrCondition("1");
                                    setOrNameCondition("<Condition>");
                                  } else {
                                    setOrCondition("1&&2");
                                    setOrNameCondition(
                                      "<Test Result> And <Condition>"
                                    );
                                  }
                                }}
                                checked={ignoreTestResult}
                              />
                            </Col>
                          </Row>
                        
                        <Row>
                          <Col>
                            {orNameCondition && (
                              <RulesScreenOrCondition
                                orNameCondition={orNameCondition}
                              />
                            )}
                          </Col>
                        </Row>
                        {orNameCondition.includes("(Days)") && (
                          <Row>
                            <Col>
                              <Toast className="bg-EFEFEF" 
                              onClose={() => setToastShow(false)}
                              show= {toastShow} 
                              style={{width: "auto"}}>
                                <Toast.Header>
                                  <strong className="me-auto" controlId="daysLogic"/>
                                </Toast.Header>
                                <Toast.Body>Note: When using different "(Days)" data fields, Rules Engine will only calculate for Event Date when Event Date is a chosen field in the Busines Rules and present in the individual case being evaluated. If Event Date is not present in the Business Rules or Event Date data is not present in a case being evaluated, Rules Engine will use other "(Days)" fields as expected.</Toast.Body>
                              </Toast>
                            </Col>
                          </Row>
                      )}
                      </Form.Group>
                      {objectsData.length > 0 && (
                        <>
                          {ignoreTestResult ? (
                            <RulesScreenDecisionTableForSyphilis
                              condition={loincDataCondition}
                              rulesList={rulesList.length > 0 ? rulesList : []}
                              objectsData={objectsData}
                              getFieldOptions={getFieldOptions}
                              getOperatorsOptions={getOperatorsOptions}
                              setRulesList={setRulesList}
                              ref={childRef}
                              orCondition={orCondition}
                              setOrCondition={setOrCondition}
                              orNameCondition={orNameCondition}
                              setOrNameCondition={setOrNameCondition}
                            />
                          ) : (
                            <RulesScreenDecisionTable
                              condition={loincDataCondition}
                              rulesList={rulesList.length > 0 ? rulesList : []}
                              objectsData={objectsData}
                              getFieldOptions={getFieldOptions}
                              getOperatorsOptions={getOperatorsOptions}
                              setRulesList={setRulesList}
                              ref={childRef}
                              orCondition={orCondition}
                              setOrCondition={setOrCondition}
                              orNameCondition={orNameCondition}
                              setOrNameCondition={setOrNameCondition}
                            />
                          )}
                        </>
                      )}
                    </Row>
                  </Card>

                  <SelectAndAttachedCodes
                    isFetchError={isFetchError}
                    setPageNoCallback={setLoincPageNoCallback}
                    setRecordsPerPageCallback={setLoincRecordsPerPageCallback}
                    setSelectedRowCallback={setSelectedLoincRowCallback}
                    headCells={rulesScreenLoincCodes}
                    rows={loincData?.genericList}
                    pages={loincData?.totalPages}
                    nameLabel={"LOINC"}
                    handleShowFilter={handleShowFilter}
                    dataCondition={loincDataCondition}
                    selectedRows={selectedLoincRows}
                    attachedCodes={attachedLoincCodes}
                    applyCodes={applyLoincCodes}
                    isRulesLoincTable={true}
                  />
                  <SelectAndAttachedCodes
                    isFetchError={isFetchError}
                    setPageNoCallback={setSnomedPageNoCallback}
                    setRecordsPerPageCallback={setSnomedRecordsPerPageCallback}
                    setSelectedRowCallback={setSelectedSnomedRowCallback}
                    headCells={rulesScreenSnomedCodes}
                    rows={snomedData?.genericList}
                    pages={snomedData?.totalPages}
                    nameLabel={"SNOMED"}
                    dataCondition={loincDataCondition}
                    selectedRows={selectedSnomedRows}
                    attachedCodes={attachedSnomedCodes}
                    applyCodes={applySnomedCodes}
                    isRulesSnomedTable={true}
                  />

                  <Row className="noPaddMarginTop40">
                    <Col className="flexCenter">
                      <Button
                        className="addNewBtn flexCenter generalFont"
                        type="submit"
                      >
                        Submit
                      </Button>
                      <Button
                        className="cancelButtonStyle generalFont flexCenter"
                        onClick={cancelForm}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Form>
                <Modal
                  show={showFilterModal}
                  onHide={handleFilterModalClose}
                  size="sm"
                  centered
                  dialogClassName="my-modal-30"
                >
                  <Modal.Header className="modalHeaderContainer" closeButton>
                    <Modal.Title className="modalHeader generalFont">
                      Apply Filters
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="modalBodyContainer">
                    <React.Fragment>
                      <Form.Label className="modalLabel generalFont">
                        <TextField
                          className="my-modal-searchbox-30"
                          size="small"
                          placeholder="Search LOINC"
                          value={filter.searchText ? filter.searchText : ""}
                          onChange={(e) =>
                            setFilterField("searchText", e.target.value)
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="start">
                                <img
                                  src={`${validateAndSanitizeUrl(
                                    S3_URL
                                  )}search-icon.png`}
                                  alt=""
                                  style={{ height: "19px", width: "19px" }}
                                ></img>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Form.Label>
                      <br />
                      <br />
                      <Accordion
                        alwaysOpen
                        disablegutters="true"
                        defaultActiveKey={setExpandedAccordion()}
                      >
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            <div className="bold">Test Method</div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <FormGroup>
                              <FixedSizeList
                                height={200}
                                itemSize={40}
                                itemCount={
                                  testMethodCodeSets.sort((a, b) =>
                                    a.reference_Code_description.localeCompare(
                                      b.reference_Code_description
                                    )
                                  ).length
                                }
                              >
                                {({ index, style }) => (
                                  <div style={style}>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={testMethodCheckedValues.includes(
                                            testMethodCodeSets[index]
                                              .reference_Code_description
                                          )}
                                          onChange={
                                            handleTestMethodCheckboxChange
                                          }
                                          name={
                                            testMethodCodeSets[index]
                                              .reference_Code_description
                                          }
                                        />
                                      }
                                      label={
                                        testMethodCodeSets[index]
                                          .reference_Code_description
                                      }
                                    />
                                  </div>
                                )}
                              </FixedSizeList>
                            </FormGroup>
                          </Accordion.Body>
                        </Accordion.Item>
                        <br />
                        <Accordion.Item eventKey="1">
                          <Accordion.Header>
                            <div className="bold">Status</div>
                          </Accordion.Header>
                          <Accordion.Body>
                            <FormGroup>
                              <FormControlLabel
                                control={<Checkbox />}
                                label="Active"
                                checked={filter.active ? true : false}
                                onChange={(e) =>
                                  setFilterField("active", e.target.checked)
                                }
                              />
                              <FormControlLabel
                                control={<Checkbox />}
                                label="Inactive"
                                checked={filter.inactive ? true : false}
                                onChange={(e) =>
                                  setFilterField("inactive", e.target.checked)
                                }
                              />
                            </FormGroup>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </React.Fragment>
                  </Modal.Body>
                  <Modal.Footer
                    className="modalFooterContainer"
                    style={{
                      justifyContent: "space-between",
                      marginLeft: "23px",
                    }}
                  >
                    <Button
                      onClick={handleResetFilter}
                      className="modalAddUpdateStyle generalFont flexCenter modalRemoveStyle"
                    >
                      Reset
                    </Button>
                    <Button
                      onClick={handleFilter}
                      className="modalAddUpdateStyle generalFont flexCenter"
                    >
                      Filter
                    </Button>
                  </Modal.Footer>
                </Modal>
              </TabPanel>
              <TabPanel style={{ padding: "0px", marginTop: "40px" }} value="2">
                <Form
                  onSubmit={handleSubmmitTranslationRule}
                  noValidate
                  validated={validated}
                >
                  <Card className="card">
                    <Row style={{ padding: "40px 40px 0 40px" }}>
                      <div
                        className="cardBody"
                        style={{ marginBottom: "40px" }}
                      >
                        <img
                          src={`${validateAndSanitizeUrl(
                            S3_URL
                          )}rules-details-icon.png`}
                          style={{
                            width: "20px",
                            height: "18px",
                            marginRight: "15px",
                          }}
                          alt=""
                        ></img>
                        <div className="condModalHeader generalFont">
                          Rule Details
                        </div>
                      </div>
                      <Col>
                        <Form.Group className="mb-3" controlId="ruleName">
                          <Form.Label className="modalLabel generalFont">
                            Rule Name <i className="text-danger">(required)</i>
                          </Form.Label>
                          <Form.Control
                            className="modalInput generalFont"
                            type="text"
                            placeholder="Hint Text"
                            required
                            value={form.ruleName}
                            onChange={(e) =>
                              setField("ruleName", e.target.value)
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="status">
                          <Form.Label
                            className="modalLabel generalFont"
                            style={{ marginLeft: "80px" }}
                          >
                            Status <i className="text-danger">(required)</i>
                          </Form.Label>
                          <br />
                          <Form.Check
                            style={{ marginLeft: "80px", marginTop: "15px" }}
                            name="status"
                            required
                            value="active"
                            type="radio"
                            label="Active"
                            inline
                            onChange={(e) => setField("status", e.target.value)}
                            checked={form.status === "active"}
                          />
                          <Form.Check
                            name="status"
                            required
                            value="inactive"
                            type="radio"
                            label="Inactive"
                            inline
                            onChange={(e) => setField("status", e.target.value)}
                            checked={form.status === "inactive"}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row style={{ padding: "40px 40px 0 40px" }}>
                      <Col xl={6}>
                        <Form.Group className="mb-3" controlId="form.facility">
                          <Form.Label className="modalLabel generalFont">
                            Facility <i className="text-danger">(required)</i>
                          </Form.Label>

                          {facilityData && (
                            <Autocomplete
                              multiple
                              id="tags-standard"
                              options={facilityData.sort(
                                (a, b) =>
                                  -b.sendingFacilityName.localeCompare(
                                    a.sendingFacilityName
                                  )
                              )}
                              getOptionLabel={(option) => {
                                return (
                                  option?.sendingFacilityName?.trim() +
                                  "-" +
                                  (option?.clia !== null
                                    ? "-" + option?.clia?.trim()
                                    : "")
                                );
                              }}
                              value={
                                selectedSendingFacility.length > 0
                                  ? selectedSendingFacility
                                  : []
                              }
                              onChange={(event, newValue) => {
                                setSelectedSendingFacility(newValue);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="standard"
                                  placeholder="Search Sending Facility"
                                />
                              )}
                            />
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row style={{ padding: "40px" }}>
                      <Col>
                        <Form.Group className="mb-3" controlId="description">
                          <Form.Label className="modalLabel generalFont">
                            Description
                          </Form.Label>
                          <Form.Control
                            className="modalInput generalFont"
                            type="text"
                            placeholder="Hint Text"
                            value={form.description}
                            onChange={(e) =>
                              setField("description", e.target.value)
                            }
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card>
                  <Card className="card" style={{ marginTop: "40px" }}>
                    <Row style={{ padding: "40px 40px 0 40px" }}>
                      <Col className="flexRow flexCenter">
                        <img
                          src={`${validateAndSanitizeUrl(
                            S3_URL
                          )}condition-icon.png`}
                          alt=""
                          className="ruleModalCondIcon"
                        ></img>
                        <div className="condModalHeader generalFont">
                          Conditions
                        </div>
                      </Col>
                    </Row>
                    <br />
                    {inputConditions.map((input, index) => {
                      return (
                        <Row
                          style={{ padding: "30px 40px 0 40px" }}
                          key={index}
                        >
                          <Col sm={1}>
                            {index === 0 ? (
                              <div className="bold">If</div>
                            ) : (
                              <Form.Select
                                key={index + "If"}
                                name="logicalOperator"
                                className="modalInput generalFont"
                                required
                                value={
                                  input.logicalOperator
                                    ? input.logicalOperator
                                    : ""
                                }
                                disabled={index > 1}
                                onChange={(event) =>
                                  handleFormConditionsChange(index, event)
                                }
                              >
                                <option key="&&" value="&&">
                                  And
                                </option>
                                <option key="||" value="||">
                                  Or
                                </option>
                              </Form.Select>
                            )}
                          </Col>
                          <Col>
                            <Form.Select
                              key={index + "Object"}
                              name="sourceObject"
                              className="modalInput generalFont"
                              aria-label="Object"
                              required
                              disabled={
                                index > 0 && inputConditions.at(index) !== ""
                              }
                              value={inputConditions.at(index).sourceObject}
                              onChange={(event) =>
                                handleFormConditionsChange(index, event)
                              }
                            >
                              <option disabled value="">
                                Object
                              </option>
                              {objectsData
                                .filter(
                                  (item) =>
                                    item.description !==
                                      "Surveillance System" &&
                                    item.description !== "Configurations"
                                )
                                .map((val) => {
                                  return (
                                    <option
                                      key={val.referenceTableName}
                                      value={val.description}
                                    >
                                      {val.description}
                                    </option>
                                  );
                                })}
                            </Form.Select>
                          </Col>
                          <Col>
                            <Form.Select
                              key={index + "Field"}
                              name="sourceField"
                              className="modalInput generalFont"
                              aria-label="Field"
                              required
                              value={input.sourceField}
                              disabled={
                                index === 0 &&
                                inputConditions.at(0).sourceObject === ""
                              }
                              onChange={(event) =>
                                handleFormConditionsChange(index, event)
                              }
                            >
                              <option disabled value="">
                                Field
                              </option>
                              {/* {getFieldOptions(
                                inputConditions.at(index).sourceObject
                              )} */}
                              {getFieldOptions(
                                inputConditions.at(index).sourceObject
                              ).map((item) => {
                                return (
                                  <option
                                    key={item.referenceTableValueId}
                                    value={item.reference_code}
                                  >
                                    {item.reference_Code_description}
                                  </option>
                                );
                              })}
                            </Form.Select>
                          </Col>
                          <Col>
                            <Form.Select
                              key={index + "Operator"}
                              name="operator"
                              className="modalInput generalFont"
                              aria-label="Operator"
                              required
                              value={input.operator}
                              disabled={
                                index === 0 &&
                                inputConditions.at(0).sourceObject === ""
                              }
                              onChange={(event) =>
                                handleFormConditionsChange(index, event)
                              }
                            >
                              <option disabled value="">
                                Operator
                              </option>
                              {getOperatorsOptions(
                                inputConditions.at(index).sourceObject,
                                inputConditions.at(index).sourceField
                              ).map(([key, val]) => {
                                return (
                                  <option key={val} value={val}>
                                    {val}
                                  </option>
                                );
                              })}
                            </Form.Select>
                          </Col>
                          <Col>{changeConditionInputType(input, index)}</Col>
                          <Col sm={1}>
                            {index !== 0 && (
                              <Button
                                className="removeButtonStyle generalFont flexCenter"
                                onClick={() => removeConditionsFields(index)}
                              >
                                <img
                                  src={`${validateAndSanitizeUrl(
                                    S3_URL
                                  )}cancel-icon.png`}
                                  alt=""
                                ></img>
                              </Button>
                            )}
                          </Col>
                        </Row>
                      );
                    })}
                    <Row style={{ padding: "30px 40px 40px 40px" }}>
                      <Col sm={1}></Col>
                      <Col>
                        <Button
                          className="tableFilterByBtn flexCenter generalFont"
                          onClick={addConditionsFields}
                          disabled={inputConditions[0].sourceObject === ""}
                        >
                          <img
                            style={{ marginRight: "10px" }}
                            src={`${validateAndSanitizeUrl(
                              S3_URL
                            )}plus-vector-blue-icon.png`}
                            className="ruleModalAddIcon"
                            alt=""
                          ></img>
                          Add Condition
                        </Button>
                      </Col>
                    </Row>
                  </Card>
                  <Card className="card" style={{ marginTop: "40px" }}>
                    <Row style={{ padding: "40px 40px 0 40px" }}>
                      <Col className="flexRow flexCenter">
                        <img
                          src={`${validateAndSanitizeUrl(
                            S3_URL
                          )}action-icon.png`}
                          alt=""
                          className="ruleModalCondIcon"
                        ></img>
                        <div className="condModalHeader generalFont">
                          Action
                        </div>
                      </Col>
                    </Row>
                    <br />
                    {inputActions.map((input, index) => {
                      return (
                        <Row
                          style={{ padding: "30px 40px 0 40px" }}
                          key={index}
                        >
                          <Col sm={1}>
                            {index === 0 && <div className="bold">Then</div>}
                          </Col>
                          <Col>
                            <Form.Select
                              key={index + "Object2"}
                              name="sourceObject"
                              className="modalInput generalFont"
                              aria-label="Object"
                              required
                              value={inputActions.at(0).sourceObject}
                              disabled={true}
                              onChange={(event) =>
                                handleFormActionsChange(index, event)
                              }
                            >
                              <option disabled value="">
                                Object
                              </option>
                              {objectsData
                                .filter(
                                  (item) =>
                                    item.description !==
                                      "Surveillance System" &&
                                    item.description !== "Configurations"
                                )
                                .map((val) => {
                                  return (
                                    <option
                                      key={val.referenceTableName}
                                      value={val.description}
                                    >
                                      {val.description}
                                    </option>
                                  );
                                })}
                            </Form.Select>
                          </Col>
                          <Col>
                            <Form.Select
                              key={index + "Field2"}
                              name="sourceField"
                              className="modalInput generalFont"
                              aria-label="Field"
                              required
                              disabled={
                                inputActions.at(index).sourceObject === ""
                              }
                              value={input.sourceField}
                              onChange={(event) =>
                                handleFormActionsChange(index, event)
                              }
                            >
                              <option disabled value="">
                                Field
                              </option>
                              {getFieldOptions(
                                inputActions.at(index).sourceObject
                              ).map((item) => {
                                return (
                                  <option
                                    key={item.referenceTableValueId}
                                    value={item.reference_code}
                                  >
                                    {item.reference_Code_description}
                                  </option>
                                );
                              })}
                            </Form.Select>
                          </Col>
                          <Col>
                            <Form.Select
                              key={index + "Operator2"}
                              name="operator"
                              className="modalInput generalFont"
                              aria-label="Operator"
                              required
                              disabled={
                                inputActions.at(index).sourceObject === ""
                              }
                              value={input.operator}
                              onChange={(event) =>
                                handleFormActionsChange(index, event)
                              }
                            >
                              <option disabled value="">
                                Operator
                              </option>
                              {getOperatorsOptions(
                                inputActions.at(index).sourceObject,
                                inputActions.at(index).sourceField
                              ).map(([key, val]) => {
                                return (
                                  <option key={key} value={val}>
                                    {val}
                                  </option>
                                );
                              })}
                            </Form.Select>
                          </Col>
                          <Col>{changeActionInputType(input, index)}</Col>
                          <Col sm={1}>
                            {index !== 0 && (
                              <Button
                                className="removeButtonStyle generalFont flexCenter"
                                onClick={() => removeActionsFields(index)}
                              >
                                <img
                                  src={`${validateAndSanitizeUrl(
                                    S3_URL
                                  )}cancel-icon.png`}
                                  alt=""
                                ></img>
                              </Button>
                            )}
                          </Col>
                        </Row>
                      );
                    })}
                    <Row style={{ padding: "30px 40px 40px 40px" }}>
                      <Col sm={1}></Col>
                      <Col>
                        <Button
                          className="tableFilterByBtn flexCenter generalFont"
                          disabled={inputActions[0].sourceObject === ""}
                          onClick={addActionsFields}
                        >
                          <img
                            style={{ marginRight: "10px" }}
                            src={`${validateAndSanitizeUrl(
                              S3_URL
                            )}plus-vector-blue-icon.png`}
                            className="ruleModalAddIcon"
                            alt=""
                          ></img>
                          Add Condition
                        </Button>
                      </Col>
                    </Row>
                  </Card>
                  <Row className="noPaddMarginTop40">
                    <Col className="flexCenter">
                      <Button
                        className="addNewBtn flexCenter generalFont"
                        type="submit"
                      >
                        Submit
                      </Button>
                      <Button
                        className="cancelButtonStyle generalFont flexCenter"
                        onClick={cancelForm}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </TabPanel>
              <TabPanel className="noPaddMarginTop40" value="3">
                <Form
                  onSubmit={handleSubmmitValidRule}
                  noValidate
                  validated={validated}
                >
                  <Card className="card">
                    <Row style={{ padding: "40px 40px 0 40px" }}>
                      <div
                        className="cardBody"
                        style={{ marginBottom: "40px" }}
                      >
                        <img
                          src={`${validateAndSanitizeUrl(
                            S3_URL
                          )}rules-details-icon.png`}
                          style={{
                            width: "20px",
                            height: "18px",
                            marginRight: "15px",
                          }}
                          alt=""
                        ></img>
                        <div className="condModalHeader generalFont">
                          Rule Details
                        </div>
                      </div>
                      <Col>
                        <Form.Group className="mb-3" controlId="ruleName">
                          <Form.Label className="modalLabel generalFont">
                            Rule Name <i className="text-danger">(required)</i>
                          </Form.Label>
                          <Form.Control
                            className="modalInput generalFont"
                            type="text"
                            placeholder="Hint Text"
                            required
                            value={form.ruleName}
                            onChange={(e) =>
                              setField("ruleName", e.target.value)
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-3" controlId="status">
                          <Form.Label
                            className="modalLabel generalFont"
                            style={{ marginLeft: "80px" }}
                          >
                            Status <i className="text-danger">(required)</i>
                          </Form.Label>
                          <br />
                          <Form.Check
                            style={{ marginLeft: "80px", marginTop: "15px" }}
                            name="status"
                            required
                            value="active"
                            type="radio"
                            label="Active"
                            inline
                            onChange={(e) => setField("status", e.target.value)}
                            checked={form.status === "active"}
                          />
                          <Form.Check
                            name="status"
                            required
                            value="inactive"
                            type="radio"
                            label="Inactive"
                            inline
                            onChange={(e) => setField("status", e.target.value)}
                            checked={form.status === "inactive"}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row style={{ padding: "40px 40px 0 40px" }}>
                      <Col xl={6}>
                        <Form.Group className="mb-3" controlId="form.facility">
                          <Form.Label className="modalLabel generalFont">
                            Facility <i className="text-danger">(required)</i>
                          </Form.Label>
                          {facilityData && (
                            <Autocomplete
                              multiple
                              required
                              inputProps={{ required: true }}
                              id="tags-standard"
                              options={facilityData.sort(
                                (a, b) =>
                                  -b.sendingFacilityName.localeCompare(
                                    a.sendingFacilityName
                                  )
                              )}
                              getOptionLabel={(option) => {
                                return (
                                  option?.sendingFacilityName?.trim() +
                                  (option?.clia !== null
                                    ? "-" + option?.clia?.trim()
                                    : "")
                                );
                              }}
                              value={
                                selectedSendingFacility.length > 0
                                  ? selectedSendingFacility
                                  : []
                              }
                              onChange={(event, newValue) => {
                                setSelectedSendingFacility(newValue);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="standard"
                                  placeholder="Search Sending Facility"
                                />
                              )}
                            />
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row style={{ padding: "40px" }}>
                      <Col>
                        <Form.Group className="mb-3" controlId="description">
                          <Form.Label className="modalLabel generalFont">
                            Description
                          </Form.Label>
                          <Form.Control
                            className="modalInput generalFont"
                            type="text"
                            placeholder="Hint Text"
                            value={form.description}
                            onChange={(e) =>
                              setField("description", e.target.value)
                            }
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card>
                  <Card className="card" style={{ marginTop: "40px" }}>
                    {showConditionsInvalidMessage()}
                    <Row style={{ padding: "40px 40px 0 40px" }}>
                      <Col className="flexRow flexCenter">
                        <img
                          src={`${validateAndSanitizeUrl(
                            S3_URL
                          )}condition-icon.png`}
                          alt=""
                          className="ruleModalCondIcon"
                        ></img>
                        <div className="condModalHeader generalFont">
                          Conditions
                        </div>
                      </Col>
                    </Row>
                    <br />
                    {inputConditions.map((input, index) => {
                      return (
                        <Row
                          style={{ padding: "30px 40px 0 40px" }}
                          key={index}
                        >
                          <Col sm={1}>
                            {index === 0 ? (
                              <div className="bold">If</div>
                            ) : (
                              <Form.Select
                                name="logicalOperator"
                                className="modalInput generalFont"
                                required
                                value={
                                  input.logicalOperator
                                    ? input.logicalOperator
                                    : ""
                                }
                                disabled={index > 1}
                                onChange={(event) =>
                                  handleFormConditionsChange(index, event)
                                }
                              >
                                <option value="&&">And</option>
                                <option value="||">Or</option>
                              </Form.Select>
                            )}
                          </Col>
                          <Col>
                            <Form.Select
                              name="sourceObject"
                              className="modalInput generalFont"
                              aria-label="Object"
                              required
                              disabled={
                                index > 0 && inputConditions.at(index) !== ""
                              }
                              value={inputConditions.at(index).sourceObject}
                              onChange={(event) =>
                                handleFormConditionsChange(index, event)
                              }
                            >
                              <option disabled value="">
                                Object
                              </option>
                              {objectsData
                                .filter(
                                  (item) =>
                                    item.description !==
                                      "Surveillance System" &&
                                    item.description !== "Configurations"
                                )
                                .map((val) => {
                                  return (
                                    <option
                                      key={val.referenceTableName}
                                      value={val.description}
                                    >
                                      {val.description}
                                    </option>
                                  );
                                })}
                            </Form.Select>
                          </Col>
                          <Col>
                            <Form.Select
                              name="sourceField"
                              className="modalInput generalFont"
                              aria-label="Field"
                              required
                              value={input.sourceField}
                              disabled={
                                index === 0 &&
                                inputConditions.at(0).sourceObject === ""
                              }
                              onChange={(event) =>
                                handleFormConditionsChange(index, event)
                              }
                            >
                              <option disabled value="">
                                Field
                              </option>
                              {getFieldOptions(
                                inputConditions.at(index).sourceObject
                              ).map((item) => {
                                return (
                                  <option
                                    key={item.referenceTableValueId}
                                    value={item.reference_code}
                                  >
                                    {item.reference_Code_description}
                                  </option>
                                );
                              })}
                            </Form.Select>
                          </Col>
                          <Col>
                            <Form.Select
                              name="operator"
                              className="modalInput generalFont"
                              aria-label="Operator"
                              required
                              value={input.operator}
                              disabled={
                                index === 0 &&
                                inputConditions.at(0).sourceObject === ""
                              }
                              onChange={(event) =>
                                handleFormConditionsChange(index, event)
                              }
                            >
                              <option disabled value="">
                                Operator
                              </option>
                              {getValidationOperatorsOptions(
                                inputConditions.at(index).sourceObject,
                                inputConditions.at(index).sourceField
                              ).map(([key, val]) => {
                                return (
                                  <option key={key} value={val}>
                                    {val}
                                  </option>
                                );
                              })}
                            </Form.Select>
                          </Col>
                          <Col>{changeConditionInputType(input, index)}</Col>
                          <Col sm={1}>
                            {index !== 0 && (
                              <Button
                                className="removeButtonStyle generalFont flexCenter"
                                onClick={() => removeConditionsFields(index)}
                              >
                                <img
                                  src={`${validateAndSanitizeUrl(
                                    S3_URL
                                  )}cancel-icon.png`}
                                  alt=""
                                ></img>
                              </Button>
                            )}
                          </Col>
                        </Row>
                      );
                    })}
                    <Row style={{ padding: "30px 40px 40px 40px" }}>
                      <Col sm={1}></Col>
                      <Col>
                        <Button
                          className="tableFilterByBtn flexCenter generalFont"
                          onClick={addConditionsFields}
                          disabled={inputConditions[0].sourceObject === ""}
                        >
                          <img
                            style={{ marginRight: "10px" }}
                            src={`${validateAndSanitizeUrl(
                              S3_URL
                            )}plus-vector-blue-icon.png`}
                            className="ruleModalAddIcon"
                            alt=""
                          ></img>
                          Add Condition
                        </Button>
                      </Col>
                    </Row>
                  </Card>
                  <Card className="card" style={{ marginTop: "40px" }}>
                    <Row style={{ padding: "40px 40px 0 40px" }}>
                      <Col className="flexRow flexCenter">
                        <img
                          src={`${validateAndSanitizeUrl(
                            S3_URL
                          )}action-icon.png`}
                          alt=""
                          className="ruleModalCondIcon"
                        ></img>
                        <div className="condModalHeader generalFont">
                          Action
                        </div>
                      </Col>
                    </Row>
                    <br />
                    <Form.Group className="mb-3" controlId="action">
                      <Row
                        style={{
                          margin: "30px 40px 40px 40px",
                          backgroundColor: "#F0F5FF",
                          paddingTop: "20px",
                          width: "90%",
                        }}
                      >
                        <Col sm={1}>
                          <div className="bold">Then</div>
                        </Col>
                        <Col>
                          <Form.Check
                            value="sendToErrorQueue"
                            type="radio"
                            label="Send to Error Queue"
                            name="sendTo"
                            required={inputActions.at(0).sourceObject === ""}
                            onChange={(e) => {
                              setField("sendTo", e.target.value);
                              setInputActions([
                                {
                                  sourceObject: "",
                                  sourceField: "",
                                  operator: "",
                                  valueRhs: "",
                                  seqNum: "1",
                                },
                              ]);
                            }}
                            checked={form.sendTo === "sendToErrorQueue"}
                          />
                          <div
                            className="flexCenter"
                            style={{ marginTop: "30px" }}
                          >
                            <Form.Select
                              style={{ width: "400px", marginRight: "40px" }}
                              name="errorCode"
                              className="modalInput generalFont"
                              aria-label="Choose Error Code"
                              disabled={
                                form.sendTo == null ||
                                form.sendTo !== "sendToErrorQueue"
                              }
                              required
                              value={errorCode}
                              onChange={(e) => setErrorCode(e.target.value)}
                            >
                              <option disabled value="">
                                Choose Error Code
                              </option>
                              {errorCodes
                                .filter((item) => item.errorCode !== "RIE01")
                                .sort((a, b) =>
                                  a.errorDisplayName > b.errorDisplayName
                                    ? 1
                                    : -1
                                )
                                .map((val) => {
                                  return (
                                    <option
                                      key={val.errorRefId}
                                      value={val.errorCode}
                                    >
                                      {val.errorDisplayName}
                                    </option>
                                  );
                                })}
                            </Form.Select>
                          </div>
                        </Col>
                        <Row>
                          <hr
                            style={{ marginLeft: "12px", marginTop: "30px" }}
                          ></hr>
                        </Row>

                        <Row
                          style={{ marginTop: "20px", marginBottom: "20px" }}
                        >
                          <Col sm={1}>
                            <div className="bold">Or</div>
                          </Col>
                          <Col>
                            <Form.Check
                              value="sendToUnknownProvider"
                              type="radio"
                              label="Send to Unknown Provider"
                              name="sendTo"
                              required
                              inline
                              onChange={(e) => {
                                setField("sendTo", e.target.value);
                                setInputActions([
                                  {
                                    sourceObject: "",
                                    sourceField: "",
                                    operator: "",
                                    valueRhs: "",
                                    seqNum: "1",
                                  },
                                ]);
                              }}
                              checked={form.sendTo === "sendToUnknownProvider"}
                            />
                            <Form.Check
                              style={{ marginLeft: "40px" }}
                              value="discardMessage"
                              type="radio"
                              label="Discard Message"
                              inline
                              name="sendTo"
                              required
                              onChange={(e) => {
                                setField("sendTo", e.target.value);
                                setInputActions([
                                  {
                                    sourceObject: "",
                                    sourceField: "",
                                    operator: "",
                                    valueRhs: "",
                                    seqNum: "1",
                                  },
                                ]);
                              }}
                              checked={form.sendTo === "discardMessage"}
                            />
                          </Col>
                        </Row>
                      </Row>
                    </Form.Group>
                  </Card>
                  <Row className="noPaddMarginTop40">
                    <Col className="flexCenter">
                      <Button
                        className="addNewBtn flexCenter generalFont"
                        type="submit"
                      >
                        Submit
                      </Button>
                      <Button
                        className="cancelButtonStyle generalFont flexCenter"
                        onClick={cancelForm}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </TabPanel>
            </TabContext>
          </Box>
        </Row>
      </Container>
      <Modal
        show={showRemoveWarningModal}
        onHide={handleRemoveWarningModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Incorrect Rule Grouping Condition
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              Rule Grouping Condition is not ?
              <br />
              <br />
              The Rule Grouping Condition is incorrect. Please make the
              nessasary changes
            </Form.Label>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={handleRemoveWarningModalClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RulesScreen;
